import { FC, memo, useContext, useEffect, useState } from "react"
import YouTube from "react-youtube"
import { Data } from "./types/TypeData";
import { RenderContext } from "./CreateContext";
import { Box, Image } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "../css/nonScrollbar.module.scss"
import "../css/ImageGallery.scss";
type Props = {
  data: Data;
}

export const UrgentDeliver: FC<Props> = (props) => {
  const { data } = props
  const [[page, direction], setPage] = useState([0, 0]);
  const targetDate = new Date(data.TOPIC_AVAILABLE_TO);
  const { setRerender } = useContext(RenderContext);

  // Menu機能の有無に応じて画面のサイズを取得
  const width = process.env.REACT_APP_SHOW_MULTI_MENU === "true" ? "100%" : `${window.innerWidth}px`;
  const height = process.env.REACT_APP_SHOW_MULTI_MENU === "true" ? "100%" : `${window.innerHeight}px`;

  // 画像の設定
  const variants = {
    enter: (direction: number) => {
      return {
        x: direction > 0 ? 100 : -100,
        opacity: 0,
      };
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 100 : -100,
        opacity: 0,
      };
    },
  };
  const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
  };

  const imageIndex = (page: number) => {
    return (page % data.MEDIAS.length + data.MEDIAS.length) % data.MEDIAS.length;
  };

  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };
  const swipeConfidenceThreshold = 10000;
  useEffect(() => {
    if (data.MEDIAS[0].TYPE != "video") {
      const timerId3 = setInterval(() => {
        paginate(1);
        const currentDate = new Date();
        if (currentDate >= targetDate) {
          setRerender(false)
        }
      }, 20000)//20秒に一回カードが入れ替わる
      return () => clearInterval(timerId3);
    }
  }, [page])

  // videoのときはvideoが終わったら再レンダリングかつ1時間経ったら、再レンダリング
  useEffect(() => {
    const checkHour = () => {
      setRerender(false)
    };
    const timerId2 = setInterval(checkHour, 600000); // 1時間ごとにAPIが更新されていないかをチェック
    return () => clearInterval(timerId2);
  }, []);


  if (data.MEDIAS[0].TYPE == "video") {
    const _onReady = (event: any) => {
      event.target.setVolume(0)
      event.target.playVideo()
    }
    const _onEnd = (event: any) => {
      event.target.playVideo()
      const currentDate = new Date();
      if (currentDate >= targetDate) {
        setRerender(false)
      }
    }
    const opts = {
      height: `${height}`,
      width: "100%",
      playerVars: {
        autoPlay: 1,
        loop: 1,
        modestbranding: 1
      },
    };
    const parser = new URL(data.MEDIAS[0].URL);
    const vId = parser.searchParams.get("v");

    if (vId !== null) {
      return <YouTube
        style={{ pointerEvents: "none" }}
        opts={opts}
        videoId={vId}
        onReady={_onReady}
        onEnd={_onEnd}
      />;
    }
  } else {
    return (
      <Box
        className={styles.nonScrollbar}
        style={{
          width: `${width}`,
          height: `${height}`,
          objectFit: "contain",
          overflow: 'hidden', // スクロールバーを非表示にする
        }}
      >
        <AnimatePresence initial={false} custom={direction} >
          <motion.img
            className={styles.nonScrollbar}
            style={{
              overflow: 'hidden', // スクロールバーを非表示にする
              width: `${width}`,
              height: `${height}`,
              objectFit: "contain"
            }}
            key={page}
            src={data.MEDIAS[imageIndex(page)].URL}
            alt={"緊急配信(画像)"}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
              x: { type: 'spring', stiffness: 400, damping: 40 },
              opacity: { duration: 0.4 },
            }}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={1}
            onDragEnd={(e, { offset, velocity }) => {
              const swipe = swipePower(offset.x, velocity.x);

              if (swipe < -swipeConfidenceThreshold) {
                paginate(1);
              } else if (swipe > swipeConfidenceThreshold) {
                paginate(-1);
              }
            }}
          />
        </AnimatePresence>
        {data.MEDIAS.length > 1 && (
          <div className="dot-list-ur">
            {data.MEDIAS.map((_, index) => (
              <div
                key={index}
                className={`dot-ur ${index === imageIndex(page) ? 'active' : ''}`}
              />
            ))}
          </div>
        )}
      </Box>
    )
  }
  return null;
}